class Animations {
  constructor() {
    this.SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'animate';
    this.SCROLL_ANIMATION_ACTIVE_CLASSNAME = 'animate--active';

    this.addListeners();
  }

  addListeners() {
    window.addEventListener('DOMContentLoaded', () => this.initializeScrollAnimationTrigger());
    document.addEventListener('shopify:section:load', event => this.initializeScrollAnimationTrigger(event.target));
  }

  initializeScrollAnimationTrigger(rootEl = document) {
    const targets = rootEl.getElementsByClassName(this.SCROLL_ANIMATION_TRIGGER_CLASSNAME);
    const animationTriggerElements = Array.from(targets);

    if (animationTriggerElements.length === 0) return;

    const observer = new IntersectionObserver(this.onIntersection.bind(this), { rootMargin: '0px 0px -50px 0px' });

    animationTriggerElements.forEach(element => observer.observe(element));
  }

  onIntersection(elements, observer) {
    elements.forEach((element, index) => {
      if (element.isIntersecting) {
        const elementTarget = element.target;

        elementTarget.classList.add(this.SCROLL_ANIMATION_ACTIVE_CLASSNAME);

        if (elementTarget.hasAttribute("data-cascade")) {
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
        }

        observer.unobserve(elementTarget);
      }
    })
  }
}

new Animations();
